<template>
  <v-container id="logout">
  </v-container>
</template>

<script>
import { AUTH_LOGOUT } from '@/store/actions/auth'

export default {
  name: 'Logout',
  created () {
    this.$store
			.dispatch(AUTH_LOGOUT)
			.then(() => this.$router.push({ name: 'auth.login' }))
  }
}
</script>
